import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Quote, ChevronLeft, ChevronRight } from "lucide-react";
import { TESTIMONIALS } from "@/data/site";
import { SectionHeading } from "@/components/pp/Shared";

export default function Testimonials() {
  const [i, setI] = useState(0);
  const [dir, setDir] = useState(1);
  const go = (d) => { setDir(d); setI((p) => (p + d + TESTIMONIALS.length) % TESTIMONIALS.length); };
  const t = TESTIMONIALS[i];

  return (
    <section className="relative py-24 md:py-32 bg-[#050507]" data-testid="testimonials">
      <div className="pp-container">
        <SectionHeading overline="Voices" title="What Our Partners Say" align="center" testid="testimonials-heading" />

        <div className="relative max-w-3xl mx-auto" style={{ perspective: 1200 }}>
          <Quote className="mx-auto mb-6 text-[#f59e0b]" size={40} />
          <div className="min-h-[220px] flex items-center justify-center">
            <AnimatePresence mode="wait" custom={dir}>
              <motion.blockquote key={i}
                custom={dir}
                initial={{ opacity: 0, rotateY: dir * 25, x: dir * 60 }}
                animate={{ opacity: 1, rotateY: 0, x: 0 }}
                exit={{ opacity: 0, rotateY: dir * -25, x: dir * -60 }}
                transition={{ duration: 0.5 }}
                className="text-center"
              >
                <p className="font-display uppercase text-2xl md:text-4xl leading-tight text-white tracking-tight">"{t.quote}"</p>
                <footer className="mt-8">
                  <p className="text-[#f59e0b] font-semibold">{t.name}</p>
                  <p className="text-slate-500 text-sm">{t.role}</p>
                </footer>
              </motion.blockquote>
            </AnimatePresence>
          </div>

          <div className="flex items-center justify-center gap-4 mt-10">
            <button onClick={() => go(-1)} data-testid="testimonial-prev" aria-label="Previous"
              className="h-11 w-11 rounded-full border border-white/15 grid place-items-center text-white hover:bg-white/5 transition-colors"><ChevronLeft size={20} /></button>
            <div className="flex gap-2">
              {TESTIMONIALS.map((_, k) => (
                <span key={k} className={`h-2 rounded-full transition-all ${k === i ? "w-6 bg-[#f59e0b]" : "w-2 bg-white/20"}`} />
              ))}
            </div>
            <button onClick={() => go(1)} data-testid="testimonial-next" aria-label="Next"
              className="h-11 w-11 rounded-full border border-white/15 grid place-items-center text-white hover:bg-white/5 transition-colors"><ChevronRight size={20} /></button>
          </div>
          <p className="text-center mt-6 text-[11px] uppercase tracking-widest text-slate-600">Placeholder testimonials — replace with verified quotes before publishing.</p>
        </div>
      </div>
    </section>
  );
}
